import { measureAndLog } from '@hotjar/performance';
import { MARKS } from '@hotjar/webapp/performance';
import { getParameterByName, getUrl } from '@hotjar/webapp/features/Playbacks/store/utils';
import * as SegmentTracking from '@hotjar/webapp/domains/common/tracking/segment';
import { trackElementViewed } from '@hotjar/webapp/features/Playbacks/utils/tracking';
import { Store } from '../../../store/player/types';
import axios from 'axios';

export const performTrackRecordingViewed = (store: Store): void => {
  const {
    isLightPlayer,
    isRetakerMode,
    recording,
    isAutogenerated,
    hasLoadedFirstRecording,
    setHasLoadedFirstRecording,
    siteId,
    recordingId,
    playbacksOpener,
  } = store.getState();

  // Do not track the following events if
  // - The person is viewing the "example recording" (more details can be found in ATV-467).
  // - This is a recording used by Continuous Heatmaps to generate a screenshot.
  if (getParameterByName('demo') === 'true' || isLightPlayer || isRetakerMode || !recording) {
    return;
  }

  const recordingCreatedDate = new Date(0);
  recordingCreatedDate.setUTCSeconds(recording.created_epoch_time);

  SegmentTracking.page('playbacks.view');

  if (isAutogenerated) {
    trackElementViewed(recording, {
      element_name: 'Autogenerated Recording',
      ui_position: 'Recording Player',
    });
  }

  // datadog log
  const nbMutations = recording.page_visit_recordings.reduce((totalMutations, pageVisit) => {
    return pageVisit.events.length + totalMutations;
  }, 0);

  if (document.visibilityState !== 'visible') return;

  if (!hasLoadedFirstRecording) {
    measureAndLog({
      name: MARKS.PLAYBACKS_RECORDING_LOADED,
      extra: {
        // After validating if the new metrics work correctly, we should deprecate the 'load_time' param and use event duration instead
        load_time: Math.floor(performance.now()),
        mutations_count: nbMutations,
        duration: recording.duration,
        isFirstRecording: true,
      },
    });
    // Tracks the load time of the first recording
    setHasLoadedFirstRecording(true);
  } else {
    const startMark = performance.getEntriesByName(MARKS.PLAYBACKS_NEXT_RECORDING_FETCH_START)[0];
    const loadTime = Math.floor(performance.now()) - Math.floor(startMark.startTime);
    measureAndLog({
      name: MARKS.PLAYBACKS_RECORDING_LOADED,
      startMark: MARKS.PLAYBACKS_NEXT_RECORDING_FETCH_START,
      extra: {
        load_time: loadTime,
        mutations_count: nbMutations,
        duration: recording.duration,
        isFirstRecording: false,
      },
    });
  }

  const openerParam = playbacksOpener ? `&opener=${playbacksOpener}` : '';
  const url = `${getUrl()}${openerParam}`;
  // Registers the recording as viewed
  axios.post(`/api/v3/sites/${siteId}/recordings/${recordingId}/tracking`, {
    url,
  });
};
